/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Rag_IntroInputs */

const en_svc_rag_intro = /** @type {(inputs: Svc_Rag_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We build RAG (retrieval-augmented generation) systems: an AI knowledge base over your own documents, records and policies, used by an internal AI assistant or a customer support chatbot. Every answer shows where it came from.`)
};

const lv_svc_rag_intro = /** @type {(inputs: Svc_Rag_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veidojam RAG sistēmas — AI zināšanu bāzes, kas pirms atbildes sagatavošanas atrod vajadzīgo informāciju Jūsu dokumentos, ierakstos un noteikumos. Tās izmanto iekšējais AI asistents vai klientu atbalsta čatbots. Katrai atbildei tiek norādīti izmantotie avoti.`)
};

/**
* | output |
* | --- |
* | "We build RAG (retrieval-augmented generation) systems: an AI knowledge base over your own documents, records and policies, used by an internal AI assistant o..." |
*
* @param {Svc_Rag_IntroInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_rag_intro = /** @type {((inputs?: Svc_Rag_IntroInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Rag_IntroInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_rag_intro(inputs)
	return en_svc_rag_intro(inputs)
});